<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head flex justify-between">
      <p class="modal-card-title">
        {{ resource.name }}
      </p>
    </header>
    <section class="modal-card-body">
      <p>{{ resource.description }}</p>
    </section>
    <footer class="modal-card-foot justify-end">
      <d-btn flat @click="closeModal()">
        Close
      </d-btn>
    </footer>
  </div>
</template>
<script>
  export default {
    props: {
      resource: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      async closeModal() {
        this.$parent.close();
      },
    },
  };
</script>